import Skeleton from 'react-loading-skeleton';
import clsx from 'clsx';

interface SkeletonCellRendererProps {
  width?: number;
  height?: number;
  variant?: 'text' | 'badge' | 'toggle' | 'action';
  className?: string;
}

export function SkeletonCellRenderer({
  width = 80,
  height = 12,
  variant = 'text',
  className,
}: SkeletonCellRendererProps) {
  const getDimensions = () => {
    switch (variant) {
      case 'badge':
        return { width: 64, height: 18 };
      case 'toggle':
        return { width: 32, height: 19 };
      case 'action':
        return { width: 16, height: 24 };
      default:
        return { width, height };
    }
  };

  const dimensions = getDimensions();

  return (
    <Skeleton
      width={dimensions.width}
      height={dimensions.height}
      baseColor="var(--color-gray-200)"
      highlightColor="#fff"
      className={clsx('leading-[unset!important] items-center', className)}
      borderRadius={variant === 'badge' ? 12 : variant === 'toggle' ? 10 : 4}
    />
  );
}
